import type { AnimationEventHandler, ImgHTMLAttributes } from 'react';

type IconProps = { onAnimationEnd?: AnimationEventHandler | undefined } & ImgHTMLAttributes<SVGSVGElement>;

export function PauseIcon(props: IconProps) {
  return (
    <svg viewBox="0 0 12 14" fill="#fff" aria-hidden="true" role="img" data-testid="pause-icon" {...props}>
      <path d="M8 14h4V0H8v14zm-8 0h4V0H0v14z" />
    </svg>
  );
}
